import React from "react";
import aboutImg2 from "../images/about2.jpg";
import aboutImg3 from "../images/about1.jpg";

const TopSection = () => {
  return (
    <>
      <section id="top-section" className="top-section animate">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6">
              <div class="our_approach">
                <h2 class="mb-5">Do You Feel Like This?</h2>
                <ul>
                  <li>Feeling stuck despite doing everything right </li>
                  <li>Confused about your next step in life or career</li>
                  <li>Overthinking decisions and lacking clarity </li>
                  <li>Struggling to balance growth with inner peace </li>
                  <li>Wanting change but unsure where to begin </li>
                </ul>
              </div>
            </div>
            <div className="col-md-6">
              <div className="top_section_image">
                <img src={aboutImg2} alt="About Anchor Point Coaching" />
                <div className="top_section_imageText">
                  <p>
                    You’re not alone—and you don’t have to navigate this alone.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="top_section_image p-0 mb-md-3">
                <img src={aboutImg3} alt="About Anchor Point Coaching" />
              </div>
            </div>
            <div className="col-md-6">
              <div class="our_approach">
                <h2 class="mb-5">How Anchor Point Helps You Move Forward</h2>
                <ul>
                  <li>Gain clarity through guided conversations</li>
                  <li>Build confidence and emotional resilience</li>
                  <li>Break through self-doubt and limiting beliefs</li>
                  <li>
                    Take action with structured support and accountability{" "}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="animate top_section_two">
        <div className="container">
          <div className="row">
            <div class="col-lg-12 why_Anchor">
              <h2>The Anchor Point Method</h2>
              <div class="row mt-4">
                <div class="col-lg-3 col-md-6 mb-5">
                  <div class="mission_card">
                    <h4 class="mb-2" style={{ color: "#c3913d" }}>
                      Discover
                    </h4>
                    <p>Understand where you are and what’s holding you back</p>
                  </div>
                </div>
                <div class="col-lg-3 col-md-6 mb-5">
                  <div class="mission_card">
                    <h4 class="mb-2" style={{ color: "#c3913d" }}>
                      Align
                    </h4>
                    <p>Build clarity, mindset and emotional awareness</p>
                  </div>
                </div>
                <div class="col-lg-3 col-md-6 mb-5">
                  <div class="mission_card">
                    <h4 class="mb-2" style={{ color: "#c3913d" }}>
                      Act
                    </h4>
                    <p>Create practical, actionable steps forward</p>
                  </div>
                </div>
                <div class="col-lg-3 col-md-6 mb-5">
                  <div class="mission_card">
                    <h4 class="mb-2" style={{ color: "#c3913d" }}>
                      Grow
                    </h4>
                    <p>Sustain long-term transformation and confidence</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default TopSection;
